
import { mapActions, mapState, mapGetters } from "vuex";
import { ORDER_ACCEPTED } from "@/constants/MixpanelEvents.js";
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import OrderItemsList from "../reciever/order-items-list.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
import EmergencyLoader from "../common/emergency-loader.vue";

export default {
  components: {
    dialogCloseBtn,
    OrderItemsList,
    ResponsiveDialog,
    EmergencyLoader
  },
  data() {
    return {
      panel: null,
      preparationTime: 0,
      acceptLoading: false,
      newOrderDetails: {},
      newOrderDetailsLoading: false,
      toggleStatus: "",
      unavailableItems: [],
      itemOutOfStockLoading: false
    };
  },
  props: {
    dialog: false
  },
  watch: {
    newOrderDetails(val) {
      if (val) {
        this.preparationTime = val.order_preparation_time;
      }
    },
    // getAllChannelNewOrders(val) {
    // },
    panel(val) {
      if (
        !isNaN(val) &&
        val !== null &&
        val >= 0 &&
        val < this.getAllChannelNewOrders.length
      ) {
        this.getOrderDetailsOfSelectedPanel(val);
        this.populateUnavailableItems(this.getAllChannelNewOrders);
      }
    }
  },
  computed: {
    ...mapGetters("reciever", ["getAllChannelNewOrders"]),
    ...mapState("restaurant", ["printers"]),
    ...mapGetters("restaurant", ["getRecieverSettings"])
  },
  created() {
    this.panel = 0;
    this.$nuxt.$on("availability-toggled", (data) => {
      this.unavailableItems = this.getUpdatedUnavailableItems(
        this.unavailableItems,
        data
      );
    });
  },
  mounted() {
    this.$nuxt.$emit("stop-audio-alert");
    this.populateUnavailableItems(this.getAllChannelNewOrders);

    const actionBtnRef = this.$refs["action-btn"];
    if (Array.isArray(actionBtnRef)) {
      actionBtnRef[0].$el?.focus();
    } else {
      actionBtnRef.$el?.focus();
    }
  },
  methods: {
    ...mapActions("reciever", [
      "getOrderDetailsObj",
      "patchOrderStatus",
      "markItemOutOfStock",
      "getOrders"
    ]),
    getOrderDetailsOfSelectedPanel(index) {
      if (
        Number.isInteger(index) &&
        this.getAllChannelNewOrders &&
        this.getAllChannelNewOrders.length > 0
      ) {
        this.newOrderDetailsLoading = true;
        this.getOrderDetailsObj({
          orderId: this.getAllChannelNewOrders[index].id
        })
          .then((response) => {
            if (response) {
              this.newOrderDetails = response;
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.newOrderDetailsLoading = false;
          });
      }
    },
    handleAcceptOrder() {
      this.acceptLoading = true;
      this.$nuxt.$emit("stop-audio-alert");
      const $this = this;
      const prePanel = this.panel;
      this.patchOrderStatus({
        orderId: $this.newOrderDetails.id,
        payload: {
          new_status: "Acknowledged",
          order_preparation_time: $this.preparationTime
        }
      })
        .then((response) => {
          if (response.status === 200) {
            $this.panel = null;
            this.mixPanelTrackEvent(ORDER_ACCEPTED);
            setTimeout(function () {
              if ($this.getAllChannelNewOrders.length === 0) {
                $this.$emit("close-dialog");
              } else if (prePanel + 1 > $this.getAllChannelNewOrders.length) {
                $this.panel = 0;
              } else {
                $this.panel = prePanel;
              }
            }, 100);
            if (
              this.getRecieverSettings($this.newOrderDetails.restaurant_id)
                .enable_consolidated_kot_printer
            ) {
              $this.$nuxt.$emit(
                "initiate-print",
                $this.newOrderDetails,
                "master-kot",
                false,
                true,
                false,
                false,
                true,
                this.printers
              );
            }
            $this.$nuxt.$emit(
              "initiate-print",
              $this.newOrderDetails,
              "kot",
              false,
              true,
              false,
              false,
              true,
              this.printers
            );
            // $this.$emit("order-accepted", $this.newOrderDetails);
          } else {
            $this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          $this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          $this.acceptLoading = false;
        });
    },
    handleUpdateAndNotify(order) {
      this.itemOutOfStockLoading = true;
      const filteredOrder = this.unavailableItems.find(
        (item) => item.orderId === order.id
      );
      this.markItemOutOfStock({
        orderId: filteredOrder.orderId,
        payload: { items: filteredOrder.items }
      })
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("close-dialog");
        })
        .catch((errr) => {
          console.log(errr);
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.itemOutOfStockLoading = false;
        });
    },
    populateUnavailableItems(orders) {
      this.unavailableItems = [];
      orders.forEach((order) => {
        const data = {
          orderId: order.id,
          items: []
        };
        this.unavailableItems.push(data);
      });
    },
    isUpdateAndNotifyButton(order) {
      const filteredOrder = this.unavailableItems.find(
        (item) => item.orderId === order.id
      );
      return filteredOrder && filteredOrder.items.length > 0;
    }
  },

  beforeDestroy() {
    this.$nuxt.$off("availability-toggled");
  }
};
